export default "__VITE_ASSET___Vb0gD0N__"